import Text from '@sats-group/ui-lib/react/text';
import React from 'react';
import Breadcrumbs from '~/client/components/breadcrumbs/breadcrumbs';
import ContentBlocks from '~/client/components/content-blocks/content-blocks';
import ContentContainer from '~/client/components/content-container/content-container';
import Hero from '~/client/components/hero/hero';
import Layout from '~/client/components/layout/layout';
import type { MarketingLandingPage as Props } from './marketing-landing-page.types';

const MarketingLandingPage: React.FunctionComponent<Props> = ({
  blocks,
  breadcrumbs,
  hero,
  layout,
  title,
}) => (
  <Layout {...layout}>
    <div className="marketing-landing-page">
      {breadcrumbs && <Breadcrumbs {...breadcrumbs} />}
      {hero ? (
        <div className="marketing-landing-page__hero">
          <Hero {...hero} />
        </div>
      ) : (
        <Text
          elementName="h1"
          className="marketing-landing-page__title"
          size={Text.sizes.headline1}
          theme={Text.themes.headline}
          italic
        >
          {title}
        </Text>
      )}
      {blocks ? (
        <ContentContainer theme={ContentContainer.themes.wide}>
          <div className="marketing-landing-page__blocks">
            <ContentBlocks {...blocks} />
          </div>
        </ContentContainer>
      ) : null}
    </div>
  </Layout>
);

export default MarketingLandingPage;
